<template>
  <div class="audio-call">
    <h2>🔊 声网纯音频通话 (带本地录音)</h2>

    <!-- 连接控制 -->
    <div class="section">
      <input v-model="channelName" placeholder="频道名" :disabled="isJoined" />
      <input v-model="token" placeholder="Token (可选)" :disabled="isJoined" />
      <button @click="joinChannel" :disabled="isJoined">加入频道</button>
      <button @click="leaveChannel" :disabled="!isJoined">离开频道</button>
    </div>

    <!-- 本地音频控制（加入后显示） -->
    <div class="section" v-if="isJoined">
      <button @click="toggleMic">
        {{ isMicEnabled ? '🔇 静音' : '🎤 取消静音' }}
      </button>
      
      <!-- 新增：录音控制按钮 -->
      <button @click="startRecording" :disabled="isRecording" style="margin-left: 10px; background: #28a745;">
        ⏺ 开始录音
      </button>
      <button @click="stopRecording" :disabled="!isRecording" style="margin-left: 10px; background: #dc3545;">
        ⏹ 停止并保存
      </button>
      <span v-if="isRecording" style="margin-left: 10px; color: red;">🔴 录音中...</span>
      
      <span style="margin-left: 20px;">本地 UID: {{ localUid || '未知' }}</span>
    </div>

    <!-- 远端用户列表 -->
    <div class="remote-users" v-if="Object.keys(remoteUsers).length">
      <h3>远端参与者 ({{ Object.keys(remoteUsers).length }})</h3>
      <ul>
        <li v-for="user in remoteUsers" :key="user.uid">
          UID: {{ user.uid }} 
          <span style="color: green;">🔊 音频在线</span>
        </li>
      </ul>
    </div>
    <div v-else-if="isJoined">⏳ 等待其他人加入...</div>
  </div>
</template>


<script>
import AgoraRTC from "agora-rtc-sdk-ng";
  export default {
    name: "AudioCall",
    components: {

    },
    data() {
    return {
        client: null,
        localAudioTrack: null, // 本地音频轨道
        remoteUsers: {},// 存储远端用户对象 { uid: user }
        isJoined: false,
        isMicEnabled: true,
        localUid: null,

        // 新增：录音相关状态
        mediaRecorder: null,         // MediaRecorder 实例
        audioChunks: [],             // 存储录音数据块
        isRecording: false,          // 是否正在录音

        // 配置（请替换为实际的值）
        appId: '212c291a3bd94fba99d73f8fe73911a3',   
        channelName: 'audio-test',
        token: '007eJxTYPiqf+fSmSPc7gcudW6cdPrSGtMfu3Y3np/145TvorinK7nrFRiMDI2SjSwNE42TUixN0pISLS1TzI3TLNJSzY0tDYHCBd/7MxsCGRkcFnMzMjJAIIjPxZBYmpKZr1uSWlzCwAAAp1ImFA==',

      };
    },
    created() {

      // 1. 创建客户端（rtc 模式）
      this.client = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });

      // 2. 监听远端用户发布音频
      this.client.on('user-published', this.handleUserPublished);
      this.client.on('user-unpublished', this.handleUserUnpublished);
      this.client.on('user-left', this.handleUserLeft);

    },

    beforeDestroy() {

      // 组件销毁前必须清理资源
      this.leaveChannel();
      // 移除事件监听
      this.client.off('user-published', this.handleUserPublished);
      this.client.off('user-unpublished', this.handleUserUnpublished);
      this.client.off('user-left', this.handleUserLeft);
      
      // 如果正在录音，停止并清理
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
      }

    },
    
    methods: {

      intPage(){


      },

    // 远端用户发布流（只处理音频）
    async handleUserPublished(user, mediaType) {
      if (mediaType !== 'audio') return;

      console.log(`远端用户 ${user.uid} 发布了音频`);
      await this.client.subscribe(user, mediaType);

      if (!this.remoteUsers[user.uid]) {
        this.$set(this.remoteUsers, user.uid, user);
      }

      user.audioTrack.play();
    },

    handleUserUnpublished(user, mediaType) {
      if (mediaType !== 'audio') return;
      console.log(`远端用户 ${user.uid} 停止了音频`);
      // 保留用户信息，只是音频不可用
    },

    handleUserLeft(user) {
      console.log(`远端用户 ${user.uid} 离开`);
      this.$delete(this.remoteUsers, user.uid);
    },

    // 加入频道
    async joinChannel() {
      if (!this.appId) {
        alert('请配置 App ID');
        return;
      }
      try {
        this.localUid = await this.client.join(
          this.appId,
          this.channelName,
          this.token || null,
          null
        );
        console.log('加入成功，UID:', this.localUid);

        // 创建本地音频轨道
        this.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
        await this.client.publish([this.localAudioTrack]);

        this.isJoined = true;
        this.isMicEnabled = true;
      } catch (err) {
        console.error('加入失败', err);
        alert('加入失败，详见控制台');
      }
    },

    // 离开频道
    async leaveChannel() {
      if (!this.isJoined) return;
      try {
        // 如果正在录音，先停止
        if (this.isRecording) {
          this.stopRecording();
        }
        
        if (this.localAudioTrack) {
          this.localAudioTrack.close();
          this.localAudioTrack = null;
        }
        this.remoteUsers = {};
        await this.client.leave();
        this.isJoined = false;
        this.localUid = null;
        console.log('已离开频道');
      } catch (err) {
        console.error('离开失败', err);
      }
    },

    // 切换麦克风
    async toggleMic() {
      if (!this.localAudioTrack) return;
      await this.localAudioTrack.setEnabled(!this.isMicEnabled);
      this.isMicEnabled = !this.isMicEnabled;
    },

    // ========== 新增：录音相关方法 ==========
    
    /**
     * 开始录制本地音频
     * 使用 MediaRecorder API 将本地音频流录制为文件
     */
    startRecording() {
      if (!this.localAudioTrack) {
        alert('没有可用的音频轨道');
        return;
      }

      try {
        // 从本地音频轨道获取底层的原生 MediaStreamTrack
        // 注意：Agora 的音频轨道需要通过 getMediaStreamTrack() 获取原生 track
        const mediaStreamTrack = this.localAudioTrack.getMediaStreamTrack();
        
        // 创建一个新的 MediaStream 包含这个 track
        // MediaRecorder 构造函数需要接收 MediaStream 对象 [citation:9]
        const stream = new MediaStream([mediaStreamTrack]);
        
        // 初始化录音数据存储
        this.audioChunks = [];
        
        // 创建 MediaRecorder 实例 [citation:3][citation:6]
        // 使用浏览器默认的音频编码（通常是 Opus 编码的 WebM）
        this.mediaRecorder = new MediaRecorder(stream);
        
        // 当有音频数据可用时触发（大约每秒触发数次）[citation:3]
        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };
        
        // 录音停止时触发：将数据合并成 Blob 并下载 [citation:6]
        this.mediaRecorder.onstop = () => {
          // 将所有音频数据块合并为一个 Blob
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
          
          // 创建下载链接
          const url = URL.createObjectURL(audioBlob);
          const link = document.createElement('a');
          link.href = url;
          // 文件名包含当前时间戳，便于区分
          link.download = `recording_${new Date().getTime()}.webm`;
          link.click();
          
          // 清理 URL 对象
          URL.revokeObjectURL(url);
          
          // 清空数据块
          this.audioChunks = [];
          console.log('录音已保存');
        };
        
        // 开始录音，每秒收集一次数据 [citation:6]
        // 参数表示每次触发 ondataavailable 的最小时间间隔（毫秒）
        this.mediaRecorder.start(1000);
        this.isRecording = true;
        
        console.log('录音已开始');
      } catch (error) {
        console.error('启动录音失败:', error);
        alert('录音启动失败，请检查浏览器权限或兼容性');
      }
    },
    
    /**
     * 停止录音并触发下载
     */
    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        console.log('录音已停止');
      }
    },

    },

    mounted() {
      this.intPage();
    },

  };
</script>

<style scoped>
.audio-call {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #1d2129;
}
.audio-call h2 {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
  margin: 0 0 16px;
}
.section {
  margin: 16px 0;
  padding: 18px;
  background: #fff;
  border: 1px solid #ebedf0;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(31, 58, 110, 0.06);
}
.section input {
  padding: 8px 12px;
  margin-right: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}
.section input:focus {
  border-color: #2b5fd9;
}
.section button {
  padding: 8px 16px;
  margin-right: 10px;
  margin-top: 8px;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background: #2b5fd9;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}
.section button:disabled {
  background: #c9d2e3;
  cursor: not-allowed;
}
.remote-users h3 {
  font-size: 15px;
  font-weight: 600;
  margin: 8px 0;
}
.remote-users ul {
  list-style: none;
  padding: 0;
}
.remote-users li {
  padding: 12px 14px;
  margin: 8px 0;
  background: #eef2fb;
  border-left: 3px solid #2b5fd9;
  border-radius: 8px;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/pages/rtc.vue